// src/app/store.ts
import { configureStore } from '@reduxjs/toolkit';

import RegistrationSlice from './app/features/registration/infrastructure/slice/RegistrationSlice';
import SearchLinkSlice from './app/features/searchLink/infrastructure/slice/SearchLinkSlice';
import SearchMyNetworkSlice from './app/features/searchMyNetwork/infrastructure/slice/SearchMyNetworkSlice';
import LoginSlice from './app/features/Login/infrastructure/slice/LoginSlice';
import WhatsappLinksSlice from './app/features/whatsappLink/infrastructure/slice/whatsappLinksSlice';
import UserSlice from './app/features/admin/user/infrastructure/slice/UserSlice';
import ManageWhatsappGroupsSlice from './app/features/admin/manageWhatsappGroups/infrastructure/slice/ManageWhatsappGroupSlice';

export const store = configureStore({
  reducer: {
    // Aquí añadiremos nuestros reducers. Por ejemplo:
    // counter: counterReducer,
    registration: RegistrationSlice,
    searchLink: SearchLinkSlice,
    myNetwork: SearchMyNetworkSlice,
    login: LoginSlice,
    whatsappLinks: WhatsappLinksSlice,
    user: UserSlice,
    manageWhatsappGroups: ManageWhatsappGroupsSlice,
  },
});

// Infiere los tipos `RootState` y `AppDispatch` del propio store
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
